import { createFileRoute } from "@tanstack/react-router";
import { FeatureDetailView } from "@/lib/features/admin/FeatureDetailView";
export const Route = createFileRoute("/_app/admin/feature/$id")({
  component: FeatureDetailView
});